/*
 *
 * Recommendations constants
 *
 */

export const GET_RECOMMENDATIONS_WATCHER =
  "app/ActionPlans/Recommendations/GET_RECOMMENDATIONS_WATCHER"
export const GET_RECOMMENDATIONS_SUCCESS =
  "app/ActionPlans/Recommendations/GET_RECOMMENDATIONS_SUCCESS"
export const GET_RECOMMENDATIONS_FAILED =
  "app/ActionPlans/Recommendations/GET_RECOMMENDATIONS_FAILED"
